import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: !!localStorage.getItem("token"),
  token: localStorage.getItem("token") || null,
  tokenType: localStorage.getItem("tokenType") || null,
  memberId: localStorage.getItem("memberId") || null,
  userDetails: JSON.parse(localStorage.getItem("userDetails") || "{}"),
  loading: false,
  error: null,
  lastActivity: localStorage.getItem("lastActivity")
    ? Number.parseInt(localStorage.getItem("lastActivity"), 10)
    : null,
  sessionStart: localStorage.getItem("sessionStart")
    ? Number.parseInt(localStorage.getItem("sessionStart"), 10)
    : null,
  sessionExpired: false,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      const { token, tokenType, memberId, userDetails } = action.payload;
      const now = Date.now();

      state.isAuthenticated = true;
      state.token = token;
      state.tokenType = tokenType;
      state.memberId = memberId;
      state.userDetails = userDetails || {};
      state.lastActivity = now;
      state.sessionStart = now;
      state.sessionExpired = false;

      localStorage.setItem("token", token);
      if (tokenType) localStorage.setItem("tokenType", tokenType);
      if (memberId) localStorage.setItem("memberId", memberId);
      localStorage.setItem("userDetails", JSON.stringify(userDetails || {}));
      localStorage.setItem("lastActivity", now.toString());
      localStorage.setItem("sessionStart", now.toString());
      localStorage.removeItem("sessionExpired");
      localStorage.removeItem("isIdleTimeout");
    },

    updateActivity: (state, action) => {
      const { timestamp, skipStorage } = action.payload || {};
      const now = timestamp || Date.now();
      state.lastActivity = now;
      if (!skipStorage) {
        localStorage.setItem("lastActivity", now.toString());
      }
    },
    expireSession: (state, action) => {
      const { isIdleTimeout } = action.payload || {};
      state.sessionExpired = true;
      state.isAuthenticated = false;
      state.token = null;
      state.tokenType = null;
      state.memberId = null;
      state.userDetails = {};
      state.error = isIdleTimeout
        ? "Session expired due to inactivity"
        : "Maximum session time reached";
      localStorage.setItem("sessionExpired", "true");
      localStorage.setItem("isIdleTimeout", isIdleTimeout ? "true" : "false");
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.token = null;
      state.tokenType = null;
      state.memberId = null;
      state.userDetails = {};
      state.error = null;
      state.lastActivity = null;
      state.sessionStart = null;
      state.sessionExpired = false;

      localStorage.removeItem("token");
      localStorage.removeItem("tokenType");
      localStorage.removeItem("memberId");
      localStorage.removeItem("userDetails");
      localStorage.removeItem("lastActivity");
      localStorage.removeItem("sessionStart");
      localStorage.removeItem("sessionExpired");
      localStorage.removeItem("isIdleTimeout");
    },

    clearError: (state) => {
      state.error = null;
    },

    setUserDetails: (state, action) => {
      state.userDetails = action.payload;
      localStorage.setItem("userDetails", JSON.stringify(action.payload));
    },
  },
});

export const {
  loginSuccess,
  logout,
  clearError,
  setUserDetails,
  updateActivity,
  expireSession,
} = authSlice.actions;
export default authSlice.reducer;
